export const CLOSED_MIC_NOTIFIER = 'CLOSED_MIC_NOTIFIER';
export const CLOSED_ALL_MIC_NOTIFIER = 'CLOSED_ALL_MIC_NOTIFIER';
export const MUTED_MIC_NOTIFIER = 'MUTED_MIC_NOTIFIER';
export const UNMUTED_MIC_NOTIFIER = 'UNMUTED_MIC_NOTIFIER';
